/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ListJobsSortBy = typeof ListJobsSortBy[keyof typeof ListJobsSortBy];


export const ListJobsSortBy = {
  created_at: 'created_at',
  updated_at: 'updated_at',
  title: 'title',
  status: 'status',
} as const;
